import { isValidElement, ReactElement, ReactNode } from 'react'

import { ISegmentedControlItemProps } from '../models'

export const isItem = (child: ReactNode): child is ReactElement<ISegmentedControlItemProps> => {
  return isValidElement<ISegmentedControlItemProps>(child)
}
